import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Consts } from '@shared/consts';
import { SessionInfo } from '../authentication/auth.service';
import { GlobalSettings } from '@core/globalSettings.service';
import { ShellContextFacade } from '../shell-context/shell-context-facade.service';

@Injectable()
export class SessionHeadersInterceptor implements HttpInterceptor {
	constructor(private readonly shellContextFacade: ShellContextFacade) {}

	private get isSctAuthorizationEnabled() {
		const sessionInfo = this.getSessionInfo();

		return this.hasSessionInfo(sessionInfo);
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!this.isSctAuthorizationEnabled) {
			return next.handle(request);
		}

		const finalRequest = this.setSessionHeaders(request);

		return next.handle(finalRequest);
	}

	private setSessionHeaders(request: HttpRequest<any>) {
		const settings = this.getSessionSettings();

		if (this.hasContactId(settings)) {
			request = this.setHeader(request, Consts.HeaderKeys.LogonAsId, settings.contactId);
		}
		if (this.hasSelectedCompany(settings)) {
			request = this.setHeader(request, Consts.HeaderKeys.SelectedCompanyId, settings.selectedCompanyId);
		}

		if (this.hasSelectedDoctor(settings)) {
			request = this.setHeader(request, Consts.HeaderKeys.SelectedDoctorId, settings.selectedDoctorId);
		}

		return request;
	}

	private setHeader(request: HttpRequest<any>, headerKey: string, headerValue: any) {
		const headers = request.headers.set(headerKey, String(headerValue));

		return request.clone({ headers });
	}

	private hasSessionInfo(sessionInfo: SessionInfo) {
		return (
			sessionInfo.accessToken && sessionInfo.accessToken.trim() !== '' && sessionInfo.sessionId && sessionInfo.sessionId.trim() !== ''
		);
	}

	private hasContactId(settings: GlobalSettings) {
		return settings.contactId && settings.contactId > 0;
	}

	private hasSelectedCompany(settings: GlobalSettings) {
		return settings.selectedCompanyId && settings.selectedCompanyId > 0;
	}

	private hasSelectedDoctor(settings: GlobalSettings) {
		return settings.selectedDoctorId && settings.selectedDoctorId > 0;
	}

	private getSessionInfo(): SessionInfo {
		return this.shellContextFacade.sessionInfo || ({} as SessionInfo);
	}

	private getSessionSettings() {
		const settings = localStorage.getItem(Consts.Storage.Settings);
		const emptySettings = new GlobalSettings();

		try {
			return (JSON.parse(settings) as GlobalSettings) || emptySettings;
		} catch {
			return emptySettings;
		}
	}
}
